import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../types/graph';

/**
 * Calculate the active queue dynamically from sectionQueues and currentPage.
 * This replaces the stored activeQueue in Redux to eliminate synchronization issues.
 */
export const useActiveQueue = () => {
  const currentPage = useSelector(
    (state: RootState) => state.graph.currentPage,
  );
  const sectionQueues = useSelector(
    (state: RootState) => state.questionnaire.sectionQueues,
  );
  const config = useSelector((state: RootState) => state.questionnaire.config);

  const activeQueue = useMemo(() => {
    const currentPageSections = config?.pages[currentPage]?.sections || [];
    return currentPageSections.flatMap(
      (section) => sectionQueues[section] || [],
    );
  }, [currentPage, sectionQueues, config]);

  return activeQueue;
};
